import { Skeleton } from '@mui/material';
import _isEmpty from 'lodash/isEmpty';
import _isNil from 'lodash/isNil';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Select from '@Components/DomElements/Select';
import SelectOption from '@Components/DomElements/SelectOption';
import { selectedOrganizationState } from '@Data/organizations/Reducer';
import TeamsApi from '@Data/teams/Api';
import { ITeam } from '@Data/teams/Interfaces';
import { activeTeamsState, selectedTeamState } from '@Data/teams/Reducer';
import { KoruRoutes } from '@Services/navigation/Paths';

const TeamsSelector = () => {
    const navigate = useNavigate();
    const selectRef = useRef();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const teams = useSelector(activeTeamsState);
    const selectedTeam = useSelector(selectedTeamState);
    const selectedOrg = useSelector(selectedOrganizationState);

    const selectedTeamName = _isNil(selectedTeam) ? '' : selectedTeam.team_name;

    useEffect(() => {
        if (_isNil(teams)) {
            setIsLoading(true);
        } else {
            setIsLoading(false);
        }
    }, [teams]);

    const handleChange = (team: ITeam) => {
        TeamsApi.setSelectedTeam(team);
        const url = KoruRoutes.root.getUrl(
            selectedOrg.organisation_id,
            team.team_id
        );
        navigate(url);
    };

    const innerHtml = isLoading ? (
        <Skeleton width={165} height={28} />
    ) : (
        <Select id="teams-selector" value={selectedTeamName} ref={selectRef}>
            {!_isNil(teams) &&
                !_isEmpty(teams) &&
                teams.map((team) => (
                    <SelectOption
                        id={`team-option-${team.team_id}`}
                        key={team.team_id}
                        parentRef={selectRef}
                        text={team.team_name}
                        onClick={() => handleChange(team)}
                    />
                ))}
        </Select>
    );

    return <React.Fragment>{innerHtml}</React.Fragment>;
};

export default TeamsSelector;
